var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPatreon = function SvgPatreon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#FF424D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.75938C20 12.925 17.425 15.5031 14.2563 15.5031C11.0781 15.5031 8.49375 12.9281 8.49375 9.75938C8.49375 6.58438 11.0781 4 14.2563 4C17.425 4 20 6.58438 20 9.75938ZM4 19.3438H6.8125V4H4V19.3438Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPatreon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgyMEMyMi4yMDkxIDAgMjQgMS43OTA4NiAyNCA0VjIwQzI0IDIyLjIwOTEgMjIuMjA5MSAyNCAyMCAyNEg0QzEuNzkwODYgMjQgMCAyMi4yMDkxIDAgMjBWNFoiIGZpbGw9IiNGRjQyNEQiLz4KPHBhdGggZD0iTTIwIDkuNzU5MzhDMjAgMTIuOTI1IDE3LjQyNSAxNS41MDMxIDE0LjI1NjMgMTUuNTAzMUMxMS4wNzgxIDE1LjUwMzEgOC40OTM3NSAxMi45MjgxIDguNDkzNzUgOS43NTkzOEM4LjQ5Mzc1IDYuNTg0MzggMTEuMDc4MSA0IDE0LjI1NjMgNEMxNy40MjUgNCAyMCA2LjU4NDM4IDIwIDkuNzU5MzhaTTQgMTkuMzQzOEg2LjgxMjVWNEg0VjE5LjM0MzhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";